export default "__VITE_ASSET__B9Y1VxrV__"